import faker from 'faker';
import _ from 'lodash';
import Store from './Store';

export default class User extends Store {
  store = {
    _id: null, 
    displayName: null, 
    image: null, 
  }


  constructor(props) {
    super(props);
    return this.setup(props);
  }

  static mock() {
    return new User({
      "email": "ttiatia@streamframe.com",
      "name": {
        "last": "Tiatia",
        "first": "Tyson"
      },
      "image": "https://randomuser.me/api/portraits/lego/3.jpg"
    });
  }

}


// WEBPACK FOOTER //
// ./src/models/User.js